/**
 * Generated by orval 🍺
 * Do not edit manually.
 * TrainLoop Platform V2 API
 * Model evaluation workbench API
 * OpenAPI spec version: 0.0.0
 */

export type DreamScanRuleMode =
  (typeof DreamScanRuleMode)[keyof typeof DreamScanRuleMode];

export const DreamScanRuleMode = {
  exclude: "exclude",
  include: "include",
} as const;
